import { default as Axios } from "axios";
import mapboxgl from "mapbox-gl";
import { DirectionsResponse, MapMatchingResponse } from "../models/Mapbox";

const axios = Axios.create({
  baseURL: "https://api.mapbox.com/",
});

export const MapboxApi = {
  mapMatching: async (coordString: string) => {
    const url = `matching/v5/mapbox/cycling?access_token=${mapboxgl.accessToken}`;
    const requestBody = `coordinates=${coordString}`;

    return await axios
      .post<MapMatchingResponse>(url, requestBody)
      .then(({ data }) => (data.code === "Ok" ? data.tracepoints : []));
  },

  directions: async (coordinates: [number, number][]) => {
    const url = `directions/v5/mapbox/cycling?access_token=${mapboxgl.accessToken}`;
    const coordinatesStr = coordinates
      .map((point) => point.join(","))
      .join(";");
    const requestBody = `coordinates=${coordinatesStr}&geometries=geojson`;

    return await axios.post<DirectionsResponse>(url, requestBody);
  },

  search: async (query: string) => {
    const params = new URLSearchParams({
      q: query,
      access_token: mapboxgl.accessToken!,
      limit: "1",
      types: "place",
    });

    const url = `search/searchbox/v1/forward?${params.toString()}`;
    return await axios.get(url);
  },
};
